export const getCurrencySymbol = (currencyCode) => {
	const symbol = currencySymbols.find(
		(symbol) => symbol.code === currencyCode,
	)?.symbol
	return symbol || currencyCode
}

const currencySymbols = [
	{ code: "AFN (؋)", symbol: "؋" },
	{ code: "ALL", symbol: "Lek" },
	{ code: "DZD", symbol: "د.ج" },
	{ code: "USD ($)", symbol: "$" },
	{ code: "EUR (€)", symbol: "€" },
	{ code: "AOA", symbol: "is" },
	{ code: "XCD", symbol: "$" },
	{ code: "XCD", symbol: "$" },
	{ code: "ARS", symbol: "$" },
	{ code: "AMD", symbol: "Դ" },
	{ code: "AWG", symbol: "ƒ" },
	{ code: "AUD", symbol: "$" },
	{ code: "EUR", symbol: "€" },
	{ code: "AZN", symbol: "₼" },
	{ code: "BSD", symbol: "$" },
	{ code: "BHD", symbol: "ب.د" },
	{ code: "BDT", symbol: "৳" },
	{ code: "BBD", symbol: "$" },
	{ code: "BYN", symbol: "p." },
	{ code: "EUR", symbol: "€" },
	{ code: "BZD", symbol: "$" },
	{ code: "XOF", symbol: "Franc" },
	{ code: "BMD", symbol: "$" },
	{ code: "BTN", symbol: "Nu" },
	{ code: "BOB", symbol: "Bs." },
	{ code: "BOV", symbol: "Mvdol" },
	{ code: "BES", symbol: "$" },
	{ code: "BAM", symbol: "КМ" },
	{ code: "BWP", symbol: "P" },
	{ code: "NOK", symbol: "kr" },
	{ code: "BRL", symbol: "R$" },
	{ code: "USD", symbol: "$" },
	{ code: "BND", symbol: "$" },
	{ code: "BGN", symbol: "лв" },
	{ code: "XOF", symbol: "Franc" },
	{ code: "BIF", symbol: "₣" },
	{ code: "CVE", symbol: "$" },
	{ code: "KHR", symbol: "៛" },
	{ code: "XAF", symbol: "CFA Franc BEAC" },
	{ code: "CAD", symbol: "$" },
	{ code: "KYD", symbol: "$" },
	{ code: "XAF", symbol: "₣" },
	{ code: "XAF", symbol: "CFA Franc BEAC" },
	{ code: "CLP", symbol: "$" },
	{ code: "CNY", symbol: "¥" },
	{ code: "AUD", symbol: "$" },
	{ code: "AUD", symbol: "$" },
	{ code: "COP", symbol: "$" },
	{ code: "KMF", symbol: "FC" },
	{ code: "CDF", symbol: "₣" },
	{ code: "NZD", symbol: "$" },
	{ code: "CRC", symbol: "₡" },
	{ code: "HRK", symbol: "Kn" },
	{ code: "CUP", symbol: "₱" },
	{ code: "ANG", symbol: "ƒ" },
	{ code: "EUR", symbol: "€" },
	{ code: "CZK", symbol: "Kč" },
	{ code: "XOF", symbol: "Franc" },
	{ code: "DKK", symbol: "kr." },
	{ code: "DJF", symbol: "₣" },
	{ code: "XCD", symbol: "$" },
	{ code: "DOP", symbol: "$" },
	{ code: "USD", symbol: "$" },
	{ code: "EGP", symbol: "£" },
	{ code: "USD", symbol: "$" },
	{ code: "XAF", symbol: "FCFA" },
	{ code: "ERN", symbol: "Nfk" },
	{ code: "EUR", symbol: "€" },
	{ code: "ETB", symbol: "Br" },
	{ code: "FKP", symbol: "£" },
	{ code: "DKK", symbol: "kr." },
	{ code: "FJD", symbol: "$" },
	{ code: "EUR", symbol: "€" },
	{ code: "EUR", symbol: "€" },
	{ code: "EUR", symbol: "€" },
	{ code: "XPF", symbol: "₣" },
	{ code: "EUR", symbol: "€" },
	{ code: "XAF", symbol: "FCFA" },
	{ code: "GMD", symbol: "D" },
	{ code: "GEL", symbol: "ლ" },
	{ code: "EUR", symbol: "€" },
	{ code: "GHS", symbol: "₵" },
	{ code: "GIP", symbol: "£" },
	{ code: "EUR", symbol: "€" },
	{ code: "DKK", symbol: "kr." },
	{ code: "XCD", symbol: "$" },
	{ code: "EUR", symbol: "€" },
	{ code: "USD", symbol: "$" },
	{ code: "GTQ", symbol: "Q" },
	{ code: "GBP", symbol: "£" },
	{ code: "GNF", symbol: "₣" },
	{ code: "XOF", symbol: "Franc" },
	{ code: "GYD", symbol: "$" },
	{ code: "HTG", symbol: "G" },
	{ code: "USD", symbol: "$" },
	{ code: "AUD", symbol: "$" },
	{ code: "EUR", symbol: "€" },
	{ code: "HNL", symbol: "L" },
	{ code: "HKD", symbol: "$" },
	{ code: "HUF", symbol: "Ft" },
	{ code: "ISK", symbol: "Kr" },
	{ code: "INR", symbol: "₨" },
	{ code: "IDR", symbol: "Rp" },
	{ code: "IRR", symbol: "﷼" },
	{ code: "IQD", symbol: "ع.د" },
	{ code: "EUR", symbol: "€" },
	{ code: "GBP", symbol: "£" },
	{ code: "ILS", symbol: "₪" },
	{ code: "EUR", symbol: "€" },
	{ code: "JMD", symbol: "$" },
	{ code: "JPY", symbol: "¥" },
	{ code: "GBP", symbol: "£" },
	{ code: "JOD", symbol: "د.ا" },
	{ code: "KZT", symbol: "〒" },
	{ code: "KES", symbol: "Sh" },
	{ code: "AUD", symbol: "$" },
	{ code: "KPW", symbol: "₩" },
	{ code: "KRW", symbol: "₩" },
	{ code: "KWD", symbol: "د.ك" },
	{ code: "KGS", symbol: "лв" },
	{ code: "LAK", symbol: "₭" },
	{ code: "EUR", symbol: "€" },
	{ code: "LBP", symbol: "ل.ل" },
	{ code: "LSL", symbol: "L" },
	{ code: "ZAR", symbol: "R" },
	{ code: "LRD", symbol: "$" },
	{ code: "LYD", symbol: "ل.د" },
	{ code: "CHF", symbol: "CHF" },
	{ code: "EUR", symbol: "€" },
	{ code: "EUR", symbol: "€" },
	{ code: "MOP", symbol: "P" },
	{ code: "MGA", symbol: "MK" },
	{ code: "MWK", symbol: "MK" },
	{ code: "MYR", symbol: "RM" },
	{ code: "MVR", symbol: "ރ" },
	{ code: "XOF", symbol: "Franc" },
	{ code: "EUR", symbol: "€" },
	{ code: "USD", symbol: "$" },
	{ code: "EUR", symbol: "€" },
	{ code: "MRU", symbol: "UM" },
	{ code: "MUR", symbol: "₨" },
	{ code: "EUR", symbol: "€" },
	{ code: "MXN", symbol: "$" },
	{ code: "MXV", symbol: "-" },
	{ code: "USD", symbol: "$" },
	{ code: "MDL", symbol: "L" },
	{ code: "EUR", symbol: "€" },
	{ code: "MNT", symbol: "₮" },
	{ code: "EUR", symbol: "€" },
	{ code: "XCD", symbol: "$" },
	{ code: "MAD", symbol: "د.م." },
	{ code: "MZN", symbol: "MTn" },
	{ code: "MMK", symbol: "Myanmar is K" },
	{ code: "NAD", symbol: "$" },
	{ code: "ZAR", symbol: "R" },
	{ code: "AUD", symbol: "$" },
	{ code: "NPR", symbol: "₨" },
	{ code: "EUR", symbol: "€" },
	{ code: "XPF", symbol: "₣" },
	{ code: "NZD", symbol: "$" },
	{ code: "NIO", symbol: "C$" },
	{ code: "XOF", symbol: "Franc" },
	{ code: "NGN", symbol: "₦" },
	{ code: "NZD", symbol: "$" },
	{ code: "AUD", symbol: "$" },
	{ code: "USD", symbol: "$" },
	{ code: "NOK", symbol: "kr" },
	{ code: "OMR", symbol: "﷼" },
	{ code: "PKR", symbol: "₨" },
	{ code: "USD", symbol: "$" },
	{ code: "PAB", symbol: "B/." },
	{ code: "USD", symbol: "$" },
	{ code: "PGK", symbol: "K" },
	{ code: "PYG", symbol: "₲" },
	{ code: "PEN", symbol: "S/." },
	{ code: "PHP (₱)", symbol: "₱" },
	{ code: "NZD", symbol: "$" },
	{ code: "PLN", symbol: "zł" },
	{ code: "EUR", symbol: "€" },
	{ code: "USD", symbol: "$" },
	{ code: "QAR", symbol: "ر.ق" },
	{ code: "MKD", symbol: "ден" },
	{ code: "RON", symbol: "L" },
	{ code: "RUB", symbol: "₽" },
	{ code: "RWF", symbol: "₣" },
	{ code: "EUR", symbol: "€" },
	{ code: "EUR", symbol: "€" },
	{ code: "SHP", symbol: "£" },
	{ code: "XCD", symbol: "$" },
	{ code: "XCD", symbol: "$" },
	{ code: "EUR", symbol: "€" },
	{ code: "EUR", symbol: "€" },
	{ code: "XCD", symbol: "$" },
	{ code: "WST", symbol: "$" },
	{ code: "EUR", symbol: "€" },
	{ code: "STN", symbol: "Db" },
	{ code: "SAR", symbol: "ر.س" },
	{ code: "XOF", symbol: "Franc" },
	{ code: "RSD", symbol: "din" },
	{ code: "SCR", symbol: "Rs" },
	{ code: "SLL", symbol: "Le" },
	{ code: "SGD", symbol: "$" },
	{ code: "ANG", symbol: "ƒ" },
	{ code: "EUR", symbol: "€" },
	{ code: "EUR", symbol: "€" },
	{ code: "SBD", symbol: "$" },
	{ code: "SOS", symbol: "Sh" },
	{ code: "ZAR", symbol: "R" },
	{ code: "SSP", symbol: "SS£" },
	{ code: "EUR", symbol: "€" },
	{ code: "LKR", symbol: "Rs" },
	{ code: "SDG", symbol: "£" },
	{ code: "SRD", symbol: "$" },
	{ code: "NOK", symbol: "kr" },
	{ code: "SZL", symbol: "L" },
	{ code: "SEK", symbol: "kr" },
	{ code: "CHF", symbol: "₣" },
	{ code: "SYP", symbol: "£" },
	{ code: "TWD", symbol: "NT$" },
	{ code: "TJS", symbol: "ЅМ" },
	{ code: "TZS", symbol: "Sh" },
	{ code: "THB", symbol: "฿" },
	{ code: "USD", symbol: "$" },
	{ code: "XOF", symbol: "Franc" },
	{ code: "NZD", symbol: "$" },
	{ code: "TOP", symbol: "T$" },
	{ code: "TTD", symbol: "$" },
	{ code: "TND", symbol: "د.ت" },
	{ code: "TRY", symbol: "TL" },
	{ code: "TMT", symbol: "m" },
	{ code: "USD", symbol: "$" },
	{ code: "AUD", symbol: "$" },
	{ code: "UGX", symbol: "Sh" },
	{ code: "UAH", symbol: "₴" },
	{ code: "AED", symbol: "د.م." },
	{ code: "GBP", symbol: "£" },
	{ code: "USD", symbol: "$" },
	{ code: "USD", symbol: "$" },
	{ code: "UYU", symbol: "$" },
	{ code: "UZS", symbol: "лв" },
	{ code: "VUV", symbol: "Vt" },
	{ code: "VEF", symbol: "Bs." },
	{ code: "VND", symbol: "₫" },
	{ code: "USD", symbol: "$" },
	{ code: "USD", symbol: "$" },
	{ code: "XPF", symbol: "Franc" },
	{ code: "MAD", symbol: "د.م." },
	{ code: "YER", symbol: "﷼" },
	{ code: "ZMW", symbol: "ZK" },
	{ code: "ZWL", symbol: "$" },
	{ code: "EUR", symbol: "€" },
]
